module.exports = __webpack_public_path__ + "static/st-jamess-palace-penny-farthing-b4ee7825ebec21e318413594babcd4ed.jpg";